module.exports = __webpack_public_path__ + "static/img/2diamond-card@3x.f470ec48.png";